import Global from './global';
import { SheetHelper } from "./sheetHelper";
import $ from 'jquery';

class SortingHelperClass {
    desktopBreakpoint = 768;

    public initSorting(): void {
        // Sorting buttons to open sheets
        const sortingBtns = document.querySelectorAll<HTMLButtonElement>('.btn-open-sorting');
        if (!sortingBtns.length) return;

        sortingBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const currentSheet = document.querySelector<HTMLElement>(".sorting-sheet");
                if (!currentSheet) return;

                SheetHelper.closeOtherSheets(currentSheet);
                SheetHelper.toggleSheet(currentSheet);
            });
        });

        // Initialize radio button sorting
        this.initSortingRadios();
    }

    private initSortingRadios(): void {
        const radios = document.querySelectorAll<HTMLInputElement>('.radio-group input[type="radio"][name="sorting"]');
        if (!radios.length) return;

        radios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                const target = e.target as HTMLInputElement;
                if (!target?.value) return;

                const newVal = target.value;

                switch (newVal) {
                    case 'alpha':
                        this.performAlphaSort('data-alpha', 'asc');
                        break;
                    case 'price':
                        this.performSort('data-price', 'asc', true);
                        break;
                    case 'price-desc':
                        this.performSort('data-price', 'desc', false);
                        break;
                    case 'review':
                        this.performSort('data-review', 'desc', false);
                        break;
                    default:
                        this.performSort('data-recommend', 'asc', false);
                        break;
                }

                // Keep all radios in sync
                radios.forEach(r => r.checked = r.value === newVal);

                // Close current sheet
                const currentSheet = target.closest<HTMLElement>('.sorting-sheet');
                if (currentSheet) SheetHelper.closeSheet(currentSheet);
            });
        });
    }

    private alphaVal(s: string): number {
        return s.toLowerCase().charCodeAt(0) - 97 + 1;
    }

    private sortByNameAsc(a: HTMLElement, b: HTMLElement): number {
        const aName = $(a).data('alpha')?.toString().toLowerCase() ?? '';
        const bName = $(b).data('alpha')?.toString().toLowerCase() ?? '';
        return aName < bName ? -1 : aName > bName ? 1 : 0;
    }

    private sortByNameDesc(a: HTMLElement, b: HTMLElement): number {
        const aName = $(a).data('alpha')?.toString().toLowerCase() ?? '';
        const bName = $(b).data('alpha')?.toString().toLowerCase() ?? '';
        return aName < bName ? 1 : aName > bName ? -1 : 0;
    }

    private performSort(df: string, direction: 'asc' | 'desc', hideUnavailable: boolean): void {
        const container = $('.hotel-list-sheet .sheet-body');
        if (!container.length) return;

        const hotels = container.find('.hotel-list-card:visible');
        if (!hotels.length) return;

        if (direction === 'asc') {
            [].sort.call(hotels, (a: any, b: any) => {
                const aVal = +($(a).attr(df) ?? 0);
                const bVal = +($(b).attr(df) ?? 0);
                return aVal - bVal;
            });
        } else {
            [].sort.call(hotels, (a: any, b: any) => {
                const aVal = +($(a).attr(df) ?? 0);
                const bVal = +($(b).attr(df) ?? 0);
                return bVal - aVal;
            });
        }

        hotels.each(function () {
            container.append(this);
            if (hideUnavailable && $(this).hasClass('unavailable')) {
                $(this).addClass('hidden');
            } else {
                $(this).removeClass('hidden');
            }
        });

        (window as any).Global?.checkLazyImages?.();

        const soldOutHotelsAlert = document.querySelectorAll<HTMLElement>('.sold-out-hotels');
        soldOutHotelsAlert.forEach(el => {
            el.classList.add("hidden");
        });

        Global.checkLazyImages();
    }

    private performAlphaSort(df: string, direction: 'asc' | 'desc'): void {
        const container = $('.hotel-list-sheet .sheet-body');
        if (!container.length) return;

        const hotels = container.find('.hotel-list-card:visible').toArray();

        if (!hotels.length) return;

        if (direction === 'asc') {
            hotels.sort((a, b) => this.sortByNameAsc(a as HTMLElement, b as HTMLElement));
        } else {
            hotels.sort((a, b) => this.sortByNameDesc(a as HTMLElement, b as HTMLElement));
        }

        hotels.forEach(hotel => container.append(hotel));

        (window as any).Global?.checkLazyImages?.();

        const soldOutHotelsAlert = document.querySelectorAll<HTMLElement>('.sold-out-hotels');
        soldOutHotelsAlert.forEach(el => {
            el.classList.add("hidden");
        });

        Global.checkLazyImages();
    }
}

// Create global instance
export const SortingHelper = new SortingHelperClass();
